import React from 'react'
import { CircularProgress, Box, SxProps, Theme } from '@mui/material'

import styles from './Loading.module.scss'

interface LoadingProps {
  loading: boolean
  children?: React.ReactNode
  fullscreen?: boolean // optional: full-page overlay
  message?: string
  color?:
    | 'primary'
    | 'secondary'
    | 'inherit'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  sx?: SxProps<Theme>
}

const Loading = ({
  loading,
  children,
  fullscreen = false,
  message,
  color = 'primary',
  sx,
}: LoadingProps) => {
  if (!loading) return <>{children}</>

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={fullscreen ? '100vh' : '100%'}
      width="100%"
      className={styles.loadingRoot}
    >
      <CircularProgress color={color} sx={sx} />
      <div className={styles.message}>{message}</div>
    </Box>
  )
}

export default Loading
